import config from "@/config/config";
import httpClient from "@/helpers/http-client";

import { CidResponse } from "@/domain/trauma.model";
import { headers } from "./headers";

export class CidService {
  private static urlApiBase = config.url_api_reclassify;

  static listValidCids = (): Promise<CidResponse[]> => {
    return httpClient
      .request<CidResponse[]>({
        url: `${this.urlApiBase}/cid/list-valid`,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
